module.exports = __webpack_public_path__ + "img/abtrennung.920dd065.jpg";